import { Avatar, Box } from '@mui/material';

const BrindeImagem = ({ src }) => {
  return (
    <Box
      sx={{
        mx: 'auto',
        width: 180,
        height: 180,
        borderRadius: '12px',
        overflow: 'hidden',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      <Avatar
        src={src}
        variant="rounded"
        sx={{ width: '100%', height: '100%' }}
      />
    </Box>
  );
};

export default BrindeImagem;
